module.exports = __webpack_public_path__ + "static/media/title_dlc_02.0bd5dc81.png";